// Copyright 2021 Sorama B.V.

export class BlobExtensions {
    /**
     * Converts a binary blob to a base 64 encoded data URI.
     * example: 'data:image/png;base64,...'
     * @param x Binary blob data.
     */
    public static toBase64Uri(x: Blob): Promise<string> {
        return new Promise((resolve, reject) => {
            // Convert blob response to base64 string
            const fileReader = new FileReader();
            fileReader.onloadend = () => {
                resolve(<string>fileReader.result);
            };
            fileReader.onerror = (e) => {
                reject(e);
            };

            fileReader.readAsDataURL(x);
        });
    }

    /**
     * Converts a binary base64 encoded data URI to a binary blob, also setting the blob type based on the input string.
     * example: 'data:image/png;base64,...'
     * @param x Base 64 encoded uri.
     */
    public static fromBase64Uri(x: string): Promise<Blob> {
        const offset = x.indexOf(",");
        const typeString = x.substr(0, offset);

        // Convert to blob
        const byteChars = atob(x.slice(offset + 1));
        const sliceSize = 512;

        const byteArrays: BlobPart[] = [];
        for (let offset = 0; offset < byteChars.length; ) {
            const size = Math.min(sliceSize, byteChars.length - offset);

            const byteNumbers = new Uint8Array(size);
            for (let i = 0; i < size; i++, offset++) {
                byteNumbers[i] = byteChars.charCodeAt(offset);
            }

            byteArrays.push(byteNumbers);
        }

        const regex = /:([a-zA-Z0-9]+\/[a-zA-Z0-9]+)/gi;
        const matches = typeString.match(regex);

        return Promise.resolve(new Blob(byteArrays, matches && matches.length > 0 ? { type: matches[0] } : undefined));
    }
}
